/** @format */
import { desktop } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
const baseStyles = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .create-alert-button {
        margin-top: var(--layout-spacing-12);
    }

    .more-in-stock-link {
        display: inline-block;
        margin-bottom: var(--layout-spacing-24);
        margin-top: var(--layout-spacing-4);
    }

    strong {
        ${theme.typography.body_normal_highlight};
        color: var(--colors-text-secondary);
    }

    ${desktop(css`
        align-items: flex-start;
        text-align: left;

        .more-in-stock-link {
            margin-bottom: var(--layout-spacing-16);
        }
    `)}
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

export const styles = css`
    ${baseStyles}
`;
